"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ignoreInSorting = [
    'AP LANG OTH THAN ENG LV 4',
    'CULTURE/LINGUISTICS',
    'LANG O/T ENGLISH I -',
    'LANG O/T ENGLISH II -',
    'LANG O/T ENGLISH III -',
    'LANG O/T ENGLISH IV -',
    'LANG CULTUR/LING'
];
var ignoredRegex = new RegExp(ignoreInSorting.join('|'));
var courseOptionsFromCourseMap = function (courseMap, reqMap, creditsRequired, name, sort) {
    if (sort === void 0) { sort = false; }
    var courses = Object.keys(reqMap)
        .map(function (key) {
        return Object.assign({}, courseMap[key], {
            credits: reqMap[key]
        });
    })
        .filter(function (c) { return c && c.course_title; });
    if (sort) {
        courses = courses.sort(function (_a, _b) {
            var a = _a.course_title;
            var b = _b.course_title;
            var trimmedA = a
                .toUpperCase()
                .replace(ignoredRegex, '')
                .trim();
            var trimmedB = b
                .toUpperCase()
                .replace(ignoredRegex, '')
                .trim();
            if (trimmedA < trimmedB)
                return -1;
            if (trimmedA > trimmedB)
                return 1;
            if (a > b)
                return -1;
            if (a < b)
                return 1;
            return 0;
        });
    }
    var creditsAvailable = courses.reduce(function (total, c) { return total + reqMap[c.course_title.toLowerCase()]; }, 0);
    return { creditsAvailable: creditsAvailable, courses: courses, creditsRequired: creditsRequired, name: name };
};
exports.default = courseOptionsFromCourseMap;
//# sourceMappingURL=courseOptionsFromCourseMap.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/utils/courseOptionsFromCourseMap.js
// module id = 41
// module chunks = 22